import { useMemo } from 'react';

import { NavMain } from '@/layout/nav/NavMain';
import { adminNavigation, visibleAdminNavigation } from './adminNavigation';
import { usePlatformRoles } from '@/hooks/usePlatformRoles';

/**
 * Die Plattform-Navigation, gefiltert nach den Rechten der Rolle
 * (ADR 0042).
 *
 * Gezeigt wird, was erlaubt ist; abgelehnt wird trotzdem am Server. Solange
 * das Profil laedt, steht hier nichts — lieber eine leere Leiste fuer einen
 * Wimpernschlag als eine, die sich vor den Augen des Benutzers zusammenzieht.
 */
export function AdminNavSidebar() {
  const { can } = usePlatformRoles();
  const items = useMemo(() => visibleAdminNavigation(adminNavigation, can), [can]);

  return (
    <nav className="bg-sidebar text-sidebar-foreground flex w-14 shrink-0 flex-col">
      <div className="flex-1 overflow-y-auto">
        <NavMain items={items} />
      </div>
    </nav>
  );
}
